import Header from "../../miscellaneous/Header";
import Status from "./01_Status/Status";
import Tickets from "./02_Tickets/Tickets";
import Dashboard from "./03_Dashboard/Dashboard";
// import DrawHistory from "./04_Draws/DrawHistory";
import { TicketMapper } from "../../../models/TicketMapper";
//import DrawDialog from "../../dialogs/DrawDialog";
import TicketsBoughtDialog from "../../dialogs/TicketsBoughtDialog";
import Footer from "../../miscellaneous/Footer";
import Floating from "../../miscellaneous/Floating";
import { usePlayerData } from "../../../hooks/usePlayerData";
import { useDialog } from "../../../hooks/useDialog";
import { ScrollRestoration } from "react-router-dom";
import AboutUs from "./07_AboutUs/AboutUs";
import DrawHistory from "./04_Draws/DrawHistory";
import Statistics from "./06_Statistics/Statistics";

export default function HomePage() {
  /**
   * Hooks
   */
  const { openDialog, closeDialog } = useDialog();
  const {
    isConnected,
    isConnecting,
    address,
    buying,
    withdrawingPrizes,
    withdrawingDonations,
    withdrawingRoyalties,
    drawInfo,
    drawDate,
    isOpen,
    drawsInHome,
    userInfo,
    ticketMappers,
    setTicketMappers,
    connectWallet,
    buyTickets,
    withdrawPrizes,
    withdrawDonations,
    withdrawRoyalties,
    statistics,
    charities,
  } = usePlayerData();

  /**
   * Tickets
   */
  function onClickNumber(
    index: number,
    number: number,
    selected: boolean,
  ): void {
    const next = [...ticketMappers];
    next[index].numbers[number] = selected;
    setTicketMappers(next);
  }
  function onClickStar(index: number, star: number, selected: boolean): void {
    const next = [...ticketMappers];
    next[index].stars[star] = selected;
    setTicketMappers(next);
  }
  function onLuckyDip(index: number): void {
    const next = [...ticketMappers];
    let numbersSelected = next[index].numbers.filter(
      (number: boolean) => number,
    ).length;
    const numbersPerTicket: number = Number(
      drawInfo?.drawConfig?.numbersPerTicket,
    );
    while (numbersSelected < numbersPerTicket) {
      const selected = Math.floor(Math.random() * next[index].numbers.length);
      if (!next[index].numbers[selected]) {
        next[index].numbers[selected] = true;
        numbersSelected++;
      }
    }
    let starsSelected = next[index].stars.filter(
      (star: boolean) => star,
    ).length;
    const starsPerTicket: number = Number(drawInfo?.drawConfig?.starsPerTicket);
    while (starsSelected < starsPerTicket) {
      const selected = Math.floor(Math.random() * next[index].stars.length);
      if (!next[index].stars[selected]) {
        next[index].stars[selected] = true;
        starsSelected++;
      }
    }
    setTicketMappers(next);
  }

  function onClear(index: number): void {
    const next = [...ticketMappers];
    next[index] = TicketMapper.empty(
      index,
      Number(drawInfo!.drawConfig.numberPool),
      Number(drawInfo!.drawConfig.starPool),
    );
    setTicketMappers(next);
  }

  function onSeeMoreEntries(): void {
    openDialog(
      TicketsBoughtDialog({
        ticketsBought: userInfo?.ticketsBought ?? [],
        drawDate: drawDate,
        onClose: closeDialog,
      }),
    );
  }

  /**
   * Render one-pager
   */
  return (
    <div className={`h-full max-w-full overflow-x-hidden`}>
      <ScrollRestoration />
      <Floating
        // onPreviousDraw={() =>
        //   openDialog(
        //     <DrawDialog
        //       draw={draws[0]}
        //       announce={true}
        //       address={address}
        //       onClose={closeDialog}
        //     ></DrawDialog>
        //   )
        // }
        isConnected={isConnected}
        connectWallet={connectWallet}
      ></Floating>
      <Header></Header>
      <Status
        drawInfo={drawInfo}
        drawDate={drawDate}
        isOpen={isOpen}
        charity={charities.find(
          (charity) =>
            charity.address?.toLocaleLowerCase() ==
            drawInfo?.charityAddress?.toLocaleLowerCase(),
        )}
      ></Status>
      <Tickets
        isConnected={isConnected}
        isConnecting={buying || isConnecting}
        connectWallet={connectWallet}
        onBuyTickets={buyTickets}
        buyingEnabled={isOpen}
        buying={buying}
        isOpened={isOpen}
        ticketMappers={ticketMappers}
        onClickNumber={onClickNumber}
        onClickStar={onClickStar}
        onLuckyDip={onLuckyDip}
        onClear={onClear}
        drawInfo={drawInfo!}
        drawDate={drawDate}
        ticketLimitPerPurchase={drawInfo!.drawConfig.ticketLimitPerPurchase}
        points={userInfo?.points ?? 0}
      ></Tickets>
      <Dashboard
        drawDate={drawDate}
        address={address}
        ticketsBought={userInfo?.ticketsBought ?? []}
        onWithdraw={withdrawPrizes}
        onWithdrawDonations={withdrawDonations}
        onWithdrawRoyalties={withdrawRoyalties}
        withdrawing={withdrawingPrizes}
        withdrawingDonations={withdrawingDonations}
        withdrawingRoyalties={withdrawingRoyalties}
        isConnected={isConnected}
        isConnecting={isConnecting}
        connectWallet={connectWallet}
        onSeeMoreTickets={onSeeMoreEntries}
        withdrawablePrize={userInfo?.toClaim}
        withdrawableDonations={userInfo?.donationsToClaim}
        withdrawableRoyalties={userInfo?.royaltiesToClaim}
        hasBeenCharity={userInfo?.hasBeenCharity ?? false}
        isOwner={userInfo?.isOwner ?? false}
        ticketLimitPerPurchase={Number(
          drawInfo!.drawConfig.ticketLimitPerPurchase,
        )}
        points={userInfo?.points ?? 0}
      ></Dashboard>
      <DrawHistory draws={drawsInHome} address={address}></DrawHistory>
      <Statistics
        statistics={statistics}
        latestDrawNumber={drawInfo!.drawNumber - 1n}
        currentCharity={drawInfo?.charityAddress}
        charities={charities}
        address={address}
      ></Statistics>
      <AboutUs></AboutUs>
      <Footer></Footer>
    </div>
  );
}
